import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/pentagon-check-green.svg'
import _imports_1 from '@/assets/img/icon/rectangular-enclamation-mark-red.svg'


const _hoisted_1 = { id: "route" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Daftar Kurir", -1)
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex font-bold mb-1" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("( ")
const _hoisted_11 = {
  key: 0,
  class: "color-green"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "text-black" }, " - ", -1)
const _hoisted_13 = {
  key: 1,
  class: "color-red"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" ) ")
const _hoisted_15 = { class: "font-bold color-blue-grey" }
const _hoisted_16 = {
  key: 0,
  class: "w-full flex"
}
const _hoisted_17 = { class: "font-semibold" }
const _hoisted_18 = { class: "flex w-full justify-between" }
const _hoisted_19 = {
  key: 0,
  src: _imports_0
}
const _hoisted_20 = {
  key: 1,
  src: _imports_1
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", {
  class: "",
  style: {"border-left":"1px solid #ECEFF1"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Column = _resolveComponent("Column")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah Kurir",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
              placeholder: "Cari Disini ...",
              canClick: true,
              onSubmitInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchData(_ctx.inputSearch))),
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _ctx.dataCourier,
          paginator: false,
          rows: _ctx.filter.top,
          stripedRows: "",
          class: "table-og",
          responsiveLayout: "scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Nama Kurir",
              style: {"width":"20%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", {
                  class: [slotProps.data.IsBlocked ? 'color-red' : 'color-primary', "font-semibold cursor-pointer"],
                  onClick: ($event: any) => (_ctx.detailData(slotProps.data))
                }, _toDisplayString(slotProps.data.Fullname), 11, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "No. Telp",
              style: {"width":"15%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_5, _toDisplayString(slotProps.data.Phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Absensi",
              style: {"width":"20%"}
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.LastAbsence)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("p", _hoisted_8, _toDisplayString(_ctx.moment(slotProps.data.LastAbsence.CreateDate).format('DD MMM')) + " ", 1),
                        _createVNode("span", _hoisted_9, [
                          _hoisted_10,
                          (slotProps.data.LastAbsence.ClockIn)
                            ? (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString(_ctx.moment(slotProps.data.LastAbsence.ClockIn).format('HH:mm')), 1))
                            : _createCommentVNode("", true),
                          _hoisted_12,
                          (slotProps.data.LastAbsence.ClockOut)
                            ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.moment(slotProps.data.LastAbsence.ClockOut).format('HH:mm')), 1))
                            : _createCommentVNode("", true),
                          _hoisted_14
                        ])
                      ]),
                      _createVNode("p", _hoisted_15, _toDisplayString(slotProps.data.LastAbsence?.MsAgenIdInNavigation?.Nama), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Kendaraan",
              style: {"width":"20%"}
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.Kendaraan)
                  ? (_openBlock(), _createBlock("div", _hoisted_16, [
                      _createVNode("p", _hoisted_17, _toDisplayString(slotProps.data?.Kendaraan?.Nama), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Akun Aktif",
              style: {"width":"15%"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_InputSwitch, {
                  disabled: !_ctx.route.meta.permission.update,
                  class: "switch-og",
                  modelValue: slotProps.data.IsActive,
                  "onUpdate:modelValue": ($event: any) => (slotProps.data.IsActive = $event),
                  onChange: ($event: any) => (_ctx.changeIsActive(slotProps.data))
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { style: {"width":"10%"} }, {
              body: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_18, [
                  (slotProps.data.IsVerified)
                    ? (_openBlock(), _createBlock("img", _hoisted_19))
                    : (_openBlock(), _createBlock("img", _hoisted_20)),
                  _hoisted_21,
                  (_ctx.route.meta.permission.update)
                    ? (_openBlock(), _createBlock("i", {
                        key: 2,
                        class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                        "aria:haspopup": "true",
                        onClick: ($event: any) => (_ctx.showDropDown($event, slotProps.data, slotProps.index))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "rows"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Paginator, {
          rows: _ctx.filter.top,
          totalRecords: _ctx.totalRecords,
          onPage: _ctx.onPage
        }, null, 8, ["rows", "totalRecords", "onPage"])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          del: _ctx.route.meta.permission.delete,
          edit: _ctx.route.meta.permission.update,
          verif: _ctx.route.meta.permission.update,
          resetKurir: _ctx.route.meta.permission.update,
          onDel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteData(_ctx.dataForm.Id))),
          onEdit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editData(_ctx.dataForm))),
          onVerif: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeIsVerified(_ctx.dataForm, _ctx.indexData))),
          onResetKurir: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetKurir(_ctx.dataForm.Username)))
        }, null, 8, ["del", "edit", "verif", "resetKurir"])
      ]),
      _: 1
    }, 512)
  ]))
}